import React, { useEffect, useState } from "react";

const BlogBody = ({ data }) => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    if (data?.body) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(data.body, "text/html");

      // const fullBannerImageUrl = data.bannerImage? `https://storage.googleapis.com/node-dev-bucket/sarcasm_co/${data.bannerImage}`: "";
      const fullBannerImageUrl = data.bannerImageUrl ? data.bannerImageUrl : "";

      console.log("Full Banner Image URL:", fullBannerImageUrl);

      const img =
        doc.querySelector("img#banner") || doc.querySelector("img.banner-img");
      if (img && fullBannerImageUrl) {
        img.setAttribute("src", fullBannerImageUrl);
        console.log("Updated img src:", img.outerHTML);
      } else {
        console.warn("Banner img not found in HTML body");
      }

      setHtmlContent(doc.body.innerHTML);
    }
  }, [data]);

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }}></div>;
};

export default BlogBody;
